import { isArray, isNil, groupBy } from 'lodash';

export const WORKER_CONFIG_TAG = 'WorkerConfiguration';

/**
 *
 * @param {*} email
 * @return {participant}
 */
export const getWorkerConfiguration = (id, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    let response = [];

    try {
      const workerConfig = await apiClient.call(WORKER_CONFIG_TAG, 'getWorkerConfiguration', { project_id: id });

      if (!isNil(workerConfig)) {
        let data = groupBy(workerConfig.data, "worker_name");
        response = Object.keys(data).map(el => {
          return {worker: el, values: data[el]}
        })
      }
    } catch (e) {
      console.log('getWorkerConfiguration error'); // eslint-disable-line no-console
      console.log(e); // eslint-disable-line no-console
    }

    callback && callback(response);

    return true;
  };
};

export const updateWorkerConfiguration = (id, newWorkerConfig, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    let response = {};
    const updates = Object.keys(newWorkerConfig).map(el => {
      return {id: Number(el.match(/\d+/g)), value: Number(newWorkerConfig[el])}
    })

    try {
      const status = await apiClient.call(
        WORKER_CONFIG_TAG,
        'createWorkerConfiguration',
        { project_id: id },
        {project_id: id, parameters: updates}
      );

      if (!isNil(status)) {
        response = status;
      }
    } catch (e) {
      console.log('updateWorkerConfiguration error'); // eslint-disable-line no-console
      console.log(e); // eslint-disable-line no-console
    }

    callback && callback(response);

    return true;
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/fileImport/workerActions.js